import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';
import { color } from 'echarts';

export const DENSITYHOUSEHOLDSACREDIFF_LAYER_ID = 'densityHouseHoldsAcreDiffLayer';

const layerConfig = {
  title: 'Household Density per acre Difference',
};

function DensityHouseHoldsAcreDiffLayer() {
  const dispatch = useDispatch();
  const { densityHouseHoldsAcreDiffLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, densityHouseHoldsAcreDiffLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (densityHouseHoldsAcreDiffLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: DENSITYHOUSEHOLDSACREDIFF_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: densityHouseHoldsAcreDiffLayer.visible,
      opacity: densityHouseHoldsAcreDiffLayer.opacity,
      getFillColor: colorBins({
        attr: 'density_households_acre_diff',
        domain: [-25, -3, -1, 0, 1, 10, 61],
        colors: [
          [178, 34, 34],
          [255, 0, 0],
          [255, 102, 102],
          [255, 204, 204],
          [224, 224, 255],
          [153, 204, 255],
          [51, 102, 255],
          [0, 0, 128],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: DENSITYHOUSEHOLDSACREDIFF_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['density_households_acre_diff', 'geo_level_id'],
            }),
          };
        }
      },
    });
  }
}

export default DensityHouseHoldsAcreDiffLayer;
